module.exports = __webpack_public_path__ + "img/ic_professioal@2x.bf2368f8.png";